export const APP_NAME = 'SAR24 - Site Activity Reports'
export const PERSIST_STORE_NAME = 'SAR24'
export const REDIRECT_URL_KEY = 'redirectUrl'
